import InputField from 'components/fields/InputField';
import MultiSelect from 'components/multipleselectoption/Index';
import branchService from 'ApiService/Admin/branchService';
import { AuthContext } from 'contexts/AuthContext';
import { useContext, useEffect, useState } from 'react';
import { RiEyeCloseLine, RiEyeLine } from 'react-icons/ri';

const HR_ROLES = [
  { value: 'hr', label: 'HR (Regular)' },
  { value: 'jrhr', label: 'JR HR' },
  { value: 'headhr', label: 'Head HR' },
];

const AddHrInfo = ({ setPlacementData, placementData, setDisable }) => {
  const { state } = useContext(AuthContext);
  const isSuperAdmin = state?.user?.role === 'superadmin';
  const isHeadHR = state?.user?.role === 'headhr';
  const isJRHRWithPermission =
    state?.user?.role === 'jrhr' && state?.user?.allPermission;
  const selectedBranch = state?.selectedBranch || '';
  const [errors, setErrors] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [branches, setBranches] = useState([]);
  const [availableBranches, setAvailableBranches] = useState([]);
  const [hrRole, setHrRole] = useState('hr');
  const [allPermission, setAllPermission] = useState(false);

  const canCreateHeadHR = isSuperAdmin;

  const capitalizeWords = (str) =>
    str.replace(/\b\w/g, (char) => char.toUpperCase());

  const isValidPhone = (phone) => /^[6-9]\d{9}$/.test(phone);

  useEffect(() => {
    if (!isSuperAdmin && !isHeadHR && !isJRHRWithPermission && selectedBranch) {
      setPlacementData((prev) => ({
        ...prev,
        hrRole: 'hr',
        allPermission: false,
        branches: prev.branches?.length > 0 ? prev.branches : [selectedBranch],
      }));
      if (branches.length === 0) {
        setBranches([{ value: selectedBranch, label: selectedBranch }]);
      }
    }
  }, [
    isSuperAdmin,
    isHeadHR,
    isJRHRWithPermission,
    selectedBranch,
    setPlacementData,
  ]);

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await branchService.getAllBranches();
        console.log('Branch API Response:', response);

        if (response?.data?.allBranches) {
          const branchList = response.data.allBranches.map((b) => ({
            value: b._id,
            label: b.name || b.Name,
          }));
          console.log('Branch List:', branchList);
          setAvailableBranches(branchList);
        }
      } catch (error) {
        console.error('Error fetching branches:', error);
      }
    };

    if (isSuperAdmin || isHeadHR || isJRHRWithPermission) {
      fetchBranches();
    }
  }, [isSuperAdmin, isHeadHR, isJRHRWithPermission]);

  const validateField = (field, value) => {
    const errors = {};

    switch (field) {
      case 'placementName':
        if (!value.trim()) {
          errors.placementName = 'Placement officer name is required.';
        }
        break;
      case 'placementEmail':
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(value)) {
          errors.placementEmail = 'Please enter a valid email address.';
        }
        break;
      case 'contactNumber':
        if (!isValidPhone(value)) {
          errors.contactNumber =
            'Please enter a valid phone number (10 digits, starting with 6-9).';
        }
        break;
      case 'placementPassword':
        const passwordPattern =
          /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,15}$/;
        if (!passwordPattern.test(value)) {
          errors.placementPassword =
            'Password must be 8-15 characters long, contain at least one uppercase letter, one number, and one special character (!@#$%^&*).';
        }
        break;
      default:
        break;
    }

    setFieldErrors((prevErrors) => ({
      ...prevErrors,
      ...errors,
      [field]: errors[field] || '',
    }));
  };

  const handleInputChange = (event) => {
    const { id, value } = event.target;
    const formattedValue =
      id === 'placementName' ? capitalizeWords(value) : value;

    setPlacementData((prevData) => ({
      ...prevData,
      [id]: formattedValue,
    }));

    validateField(id, formattedValue);
  };

  const handleRoleChange = (e) => {
    const newRole = e.target.value;
    setHrRole(newRole);

    if (newRole !== 'jrhr') {
      setAllPermission(false);
    }

    if (newRole === 'headhr') {
      setPlacementData((prev) => ({
        ...prev,
        hrRole: newRole,
        allPermission: false,
        branches: [],
      }));
      setBranches([]);
    } else if (newRole === 'jrhr') {
      setPlacementData((prev) => ({
        ...prev,
        hrRole: newRole,
        allPermission: allPermission,
        branches: [],
      }));
      setBranches([]);
    } else {
      setPlacementData((prev) => ({
        ...prev,
        hrRole: newRole,
        allPermission: false,
        branches: prev.branches || [],
      }));
    }
  };

  const handleAllPermissionToggle = (e) => {
    const checked = e.target.checked;
    setAllPermission(checked);
    setPlacementData((prev) => ({
      ...prev,
      allPermission: checked,
      branches: checked ? [] : prev.branches,
    }));
    if (checked) {
      setBranches([]);
    }
  };

  const handleBranchesChange = (selectedBranches) => {
    setBranches(selectedBranches);
    setPlacementData((prev) => ({
      ...prev,
      branches: selectedBranches.map((b) => b.value),
    }));
  };

  useEffect(() => {
    const newErrors = [];
    const {
      placementName,
      placementEmail,
      placementPassword,
      contactNumber,
      branches: selectedBranches,
      hrRole: currentRole,
      allPermission: currentAllPermission,
    } = placementData;

    if (
      !placementName ||
      !placementEmail ||
      !placementPassword ||
      !contactNumber
    ) {
      newErrors.push('Please fill in all fields.');
    }

    const canAssignBranches = isSuperAdmin || isHeadHR || isJRHRWithPermission;

    if (canAssignBranches) {
      if (currentRole === 'headhr') {
      } else if (currentRole === 'jrhr') {
        if (
          !currentAllPermission &&
          (!selectedBranches || selectedBranches.length === 0)
        ) {
          newErrors.push(
            'Please select at least one branch for JR HR without all permissions.'
          );
        }
      } else if (currentRole === 'hr') {
        if (!selectedBranches || selectedBranches.length === 0) {
          newErrors.push('Please select at least one branch for HR.');
        }
      }
    }

    if (Object.values(fieldErrors).some((error) => error)) {
      newErrors.push('Please correct the highlighted errors.');
    }

    setErrors(newErrors);
    setDisable(newErrors.length > 0);
  }, [
    placementData,
    fieldErrors,
    setDisable,
    hrRole,
    allPermission,
    branches,
    isSuperAdmin,
    isHeadHR,
    isJRHRWithPermission,
  ]);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
      <h4 className="pt-[5px] text-xl font-bold text-navy-700 dark:text-white">
        Placement Officer Information
      </h4>
      <div className="mt-5 grid grid-cols-1 gap-3 md:grid-cols-2">
        <div>
          <InputField
            extra="mb-3"
            label="Placement Officer Name"
            placeholder="Enter Placement Officer Name"
            id="placementName"
            type="text"
            onChange={handleInputChange}
            value={placementData?.placementName}
            maxLength={40}
          />
          {fieldErrors.placementName && (
            <div className="text-sm text-red-500">
              {fieldErrors.placementName}
            </div>
          )}
        </div>

        <div>
          <InputField
            extra="mb-3"
            label="Placement Officer Email"
            placeholder="Enter Placement Officer Email"
            id="placementEmail"
            type="email"
            onChange={handleInputChange}
            value={placementData?.placementEmail}
          />
          {fieldErrors.placementEmail && (
            <div className="text-sm text-red-500">
              {fieldErrors.placementEmail}
            </div>
          )}
        </div>

        <div>
          <InputField
            extra="mb-3"
            label="Contact Number"
            placeholder="Enter Contact Number"
            id="contactNumber"
            type="text"
            onChange={handleInputChange}
            value={placementData?.contactNumber}
            maxLength={10}
          />
          {fieldErrors.contactNumber && (
            <div className="text-sm text-red-500">
              {fieldErrors.contactNumber}
            </div>
          )}
        </div>

        <div className="relative mb-3 h-[calc(2.5rem+1rem)]">
          <div>
            <InputField
              extra="mb-3"
              label="Placement Officer Password"
              placeholder="Create Placement Officer's Password"
              id="placementPassword"
              type={showPassword ? 'text' : 'password'}
              onChange={handleInputChange}
              value={placementData?.placementPassword}
            />
            <button
              type="button"
              className="absolute right-4 top-12 -translate-y-1/2 transform pt-4 text-lg text-navy-700 dark:text-white"
              onClick={togglePasswordVisibility}
            >
              {showPassword ? <RiEyeLine /> : <RiEyeCloseLine />}
            </button>
          </div>

          {fieldErrors.placementPassword && (
            <div className="text-sm text-red-500">
              {fieldErrors.placementPassword}
            </div>
          )}
        </div>
      </div>

      {(isSuperAdmin || isHeadHR || isJRHRWithPermission) && (
        <div className="mt-4">
          <label className="mb-2 block text-sm font-bold text-navy-700 dark:text-white">
            HR Role <span className="text-red-500">*</span>
          </label>
          <select
            value={hrRole}
            onChange={handleRoleChange}
            className="w-full rounded-xl border border-gray-300 bg-white px-4 py-2 text-sm text-navy-700 focus:border-brand-500 focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-white"
          >
            {HR_ROLES.map((role) => (
              <option key={role.value} value={role.value}>
                {role.label}
              </option>
            ))}
          </select>
        </div>
      )}

      {(isSuperAdmin || isHeadHR || isJRHRWithPermission) &&
        hrRole === 'jrhr' && (
          <div className="mt-4 flex items-center">
            <label className="relative inline-flex cursor-pointer items-center">
              <input
                type="checkbox"
                checked={allPermission}
                onChange={handleAllPermissionToggle}
                className="peer sr-only"
              />
              <div className="peer h-6 w-11 rounded-full bg-gray-200 after:absolute after:left-[2px] after:top-[2px] after:h-5 after:w-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-[''] peer-checked:bg-brand-500 peer-checked:after:translate-x-full peer-checked:after:border-white peer-focus:outline-none dark:border-gray-600 dark:bg-gray-700 dark:peer-checked:bg-brand-500"></div>
              <span className="ml-3 text-sm font-medium text-navy-700 dark:text-white">
                All Permissions (Full Access)
              </span>
            </label>
          </div>
        )}

      {(isSuperAdmin || isHeadHR || isJRHRWithPermission) &&
        hrRole !== 'headhr' &&
        !(hrRole === 'jrhr' && allPermission) && (
          <div className="mt-4">
            <label className="mb-2 block text-sm font-bold text-navy-700 dark:text-white">
              Select Branches{' '}
              {(hrRole === 'hr' || (hrRole === 'jrhr' && !allPermission)) && (
                <span className="text-red-500">*</span>
              )}
            </label>
            <MultiSelect
              options={availableBranches.map((b) => b.label)}
              selected={branches.map((b) => b.label)}
              onChange={(selectedLabels) => {
                const selected = availableBranches.filter((b) =>
                  selectedLabels.includes(b.label)
                );
                handleBranchesChange(selected);
              }}
            />
            {branches.length === 0 && (
              <p className="mt-1 text-sm text-red-500">
                Please select at least one branch
              </p>
            )}
          </div>
        )}

      {(isSuperAdmin || isHeadHR || isJRHRWithPermission) &&
        (hrRole === 'headhr' || (hrRole === 'jrhr' && allPermission)) && (
          <p className="mt-4 text-sm text-gray-500">
            {hrRole === 'headhr'
              ? 'Head HR automatically has access to all branches'
              : 'JR HR with all permissions has access to all branches'}
          </p>
        )}

      {errors.length > 0 && (
        <div className="mt-4 text-red-500">
          {errors.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export default AddHrInfo;
